import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import Button from "components/UI/Button";
import { urlify } from "config/constants";
import Item from "../Item";
import { validateTime } from '../../../../../../common/Utils'

class View extends Component {
  componentDidUpdate() {
    document.getElementById("time_notes").innerHTML = urlify(
      this.props.time_note ? this.props.time_note : "Fetching Notes...."
    );
  }

  render() {
    const { email, address, phone, workinghours, rate, time_note } = this.props;
    let sun = " ";
    let mon = " ";
    let tue = " ";
    let wed = " ";
    let thu = " ";
    let fri = " ";
    let sat = " ";

    if (workinghours) {
      sun = workinghours["sun"];
      mon = workinghours["mon"];
      tue = workinghours["tue"];
      wed = workinghours["wed"];
      thu = workinghours["thu"];
      fri = workinghours["fri"];
      sat = workinghours["sat"];
    }

    // const { sun, mon, tue, wed, thu, fri, sat } = workinghours;

    return (
      <div style={style.wrapper}>
        <div style={style.buttonWrapper}>
          <EditButton />
        </div>
        <div style={style.itemsWrapper}>
          <Item imageName="place-white-blue.png" label="Place">
            <p style={style.itemText}>{address}</p>
          </Item>

          <Item imageName="email-icon.png" label="Email">
            <p style={style.itemText}>{email}</p>
          </Item>
          <Item imageName="contact-white-blue.png" label="Contact">
            <p style={style.itemText}>{phone}</p>
          </Item>
          <Item imageName="dollar-white-blue.png" label="Rate">
            <p style={style.itemText}>{`$${rate ? rate : "0.0"}/min`}</p>
          </Item>
        </div>

        <div>
          <h1>GYM HOURS</h1>
          <div style={style.itemsWrapper}>
            <Item label="SUN">
              <p style={style.itemText}>{sun ? validateTime(sun.start_time) : ""}</p>
              <p style={style.itemText}>{sun ? validateTime(sun.end_time) : ""}</p>
            </Item>

            <Item label="MON">
              <p style={style.itemText}>{mon ? validateTime(mon.start_time) : ""}</p>
              <p style={style.itemText}>{mon ? validateTime(mon.end_time) : ""}</p>
            </Item>
            <Item label="TUE">
              <p style={style.itemText}>{tue ? validateTime(tue.start_time) : ""}</p>
              <p style={style.itemText}>{tue ? validateTime(tue.end_time) : ""}</p>
            </Item>
            <Item label="WED">
              <p style={style.itemText}>{wed ? validateTime(wed.start_time) : ""}</p>
              <p style={style.itemText}>{wed ? validateTime(wed.end_time) : ""}</p>
            </Item>
            <Item label="THU">
              <p style={style.itemText}>{thu ? validateTime(thu.start_time) : ""}</p>
              <p style={style.itemText}>{thu ? validateTime(thu.end_time) : ""}</p>
            </Item>
            <Item label="FRI">
              <p style={style.itemText}>{fri ? validateTime(fri.start_time) : ""}</p>
              <p style={style.itemText}>{fri ? validateTime(fri.end_time) : ""}</p>
            </Item>
            <Item label="SAT">
              <p style={style.itemText}>{sat ? validateTime(sat.start_time) : ""}</p>
              <p style={style.itemText}>{sat ? validateTime(sat.end_time) : ""}</p>
            </Item>
          </div>
        </div>
        <div>
          <h1>NOTES</h1>
          <div style={style.itemsWrapper}>
            {" "}
            <p style={style.p} id="time_notes">
              {time_note}
            </p>
          </div>
        </div>
      </div>
    );
  }
}

const EditButton = withRouter(({ history }) => (
  <Button type="holo" holo style={style.editButton}
    onClick={() => {
      history.push('/gyms/gym/facilities/edit')
    }}>
    Edit
  </Button>
))

const style = {
  wrapper: {},
  editButton: {
    width: "231px",
    height: "67px",
    fontSize: "18px"
  },
  buttonWrapper: {
    display: "flex"
  },
  itemText: {
    fontSize: "20px",
    color: "#00b4d2",
    margin: "0px"
  },
  itemsWrapper: {
    display: "flex",
    justifyContent: "space-between",
    padding: "15px 40px 5px 40px"
  },
  p: {
    margin: "auto",
    padding: "25px",
    height: "100px",
    width: "80%",
    border: "2px solid #c6c6c6",
    borderRadius: "40px",
    fontSize: "16px",
    textAlign: "left",
    whiteSpace: "pre-wrap"
  }
};

export default View;
